/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SupportPhone } from '../models/SupportPhone';
import { request as __request } from '../core/request';

export class SupportService {

    /**
     * @returns SupportPhone Ok
     * @throws ApiError
     */
    public static async getSupportPhone(): Promise<SupportPhone> {
        const result = await __request({
            method: 'GET',
            path: `/support/phone`,
            errors: {
                400: `Validation Failed`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

}